module.exports = __webpack_public_path__ + "static/media/points6_6.2424b456.png";